import React, { FC, memo } from 'react'
import { IconComponent, FileWithPreview, Indent } from 'LibNeo'
import { getFileNameAndExt } from 'Helpers'
import {
	FileExtPreview,
	FileNamePreview,
	IframeStyled,
	PreviewImage,
} from 'LibNeo/components/Basic/Upload/styled'
import { Callback } from 'Types/utilTypes'

interface FileViewerProps {
	file: FileWithPreview
	onClickHandler: Callback
	isImage: boolean
}

export const FileViewer: FC<FileViewerProps> = memo(({ file, onClickHandler, isImage }) => {
	const { preview, name } = file
	const { fileName, ext } = getFileNameAndExt(name)
	return (
		<>
			<Indent bottom={24}>
				<FileNamePreview>{fileName}</FileNamePreview>
				<FileExtPreview>.{ext}</FileExtPreview>
				<IconComponent name="file-download" onClick={onClickHandler} />
			</Indent>
			{isImage ? <PreviewImage src={preview} alt={name} /> : <IframeStyled url={preview} />}
		</>
	)
})
